import { Component, input, output } from '@angular/core';

/** What the two choices are called (Lance's chat message, 28 Oct). */
export const DNE_SCOPE_KEEP_ONE_LABEL = 'Keep only one vendor';
export const DNE_SCOPE_KEEP_ALL_LABEL = 'Multiple vendor project';
/** Hover text on the whole group: say what the question is for. */
export const DNE_SCOPE_TOOLTIP =
  'This job has multiple vendors. Keep only one vendor, or choose Multiple vendor project if the vendors work different parts of the job.';

/**
 * "Keep only one vendor / Multiple vendor project" choice for the customer-DNE check (Nahid, 7 Oct; renamed 28 Oct). Not
 * stored anywhere: it only tells the next approve whether to count this vendor's estimate alone or every vendor's
 * estimate on the job.
 *
 * A host that knows the job has only one vendor passes [multiVendor]="false" and the choice disappears (Lance: it must
 * not show unless there are multiple vendors). The default is true, so a host that has not been wired keeps today's behaviour.
 * [glow] outlines the group in orange so the admin notices the new question.
 */
@Component({
  selector: 'app-dne-vendor-scope',
  standalone: true,
  template: `
    @if (multiVendor()) {
      <fieldset class="dvs" [class.dvs--glow]="glow()" [attr.title]="tooltip" data-testid="dne-vendor-scope">
        <legend class="dvs-legend">DNE check:</legend>
        <label class="dvs-opt">
          <input type="radio" [name]="name()" [checked]="!keepAll()" (change)="keepAllChange.emit(false)" />
          {{ keepOneLabel }}
        </label>
        <label class="dvs-opt">
          <input type="radio" [name]="name()" [checked]="keepAll()" (change)="keepAllChange.emit(true)" />
          {{ keepAllLabel }}
        </label>
      </fieldset>
    }
  `,
  styles: [
    `
      .dvs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 2px 10px;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 11.5px;
        line-height: 1.3;
        color: #374151;
      }
      .dvs--glow {
        padding: 3px 8px;
        border: 1px solid #f97316;
        border-radius: 6px;
        background: #fff7ed;
        box-shadow:
          0 0 0 2px rgba(249, 115, 22, 0.14),
          0 0 6px rgba(249, 115, 22, 0.3);
      }
      .dvs-legend {
        float: left;
        padding: 0;
        margin-right: 2px;
        font-weight: 600;
        white-space: nowrap;
      }
      .dvs-opt {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        cursor: pointer;
        white-space: nowrap;
      }
      .dvs-opt input {
        margin: 0;
        width: 12px;
        height: 12px;
      }
    `,
  ],
})
export class DneVendorScopeComponent {
  /** true = Multiple vendor project (count every vendor's estimate). */
  readonly keepAll = input(false);
  /** Radio group name (unique per host so two choosers never share a group). */
  readonly name = input('dne-vendor-scope');
  /** false hides the whole choice: the job has a single vendor. */
  readonly multiVendor = input(true);
  /** Orange outline + glow around the group. */
  readonly glow = input(false);
  readonly keepAllChange = output<boolean>();

  readonly keepOneLabel = DNE_SCOPE_KEEP_ONE_LABEL;
  readonly keepAllLabel = DNE_SCOPE_KEEP_ALL_LABEL;
  readonly tooltip = DNE_SCOPE_TOOLTIP;
}
